import BaseComponentController from '.././base-component.controller';

class ExecutiveManagerController extends BaseComponentController {
    constructor(_, componentRegistryService, $q) {
        super(_, componentRegistryService, $q);
        this.vm = {
            errors: []
        };
    }

    init() {
        this.vm = {
            errors:[],
            executiveManagerDetails: this.model ? this.executiveManagers.filter((em) => em.curtinId === this.model)[0] : null
        };   
    }

    validate() {
        if (this.readonly) {
            return true;
        }

        if (!this.model) {
            this.vm.errors = [`${this.fieldName} is a required field`];
        } else {
            this.vm.errors = [];
        }
        return this.vm.errors.length === 0;
    }

    validateAsync() {
        return this.getPromise(this.validate());
    }
}

ExecutiveManagerController.$inject = ['_', 'componentRegistryService','$q'];

export default  {
controller: ExecutiveManagerController,
    bindings: {
    fieldName: '@',
    modelName: '@',
    executiveManagers: '<',
    readonly: '<'
    },
templateUrl:`app/components/executive-manager-select/executive-manager-select.html`
};


// WEBPACK FOOTER //
// ./app/components/executive-manager-select/executive-manager-select.component.js